import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParent } from '../context/ParentContext';
import AddStudentModal from '../components/modals/AddStudentModal';
import ParentEmptyState from '../components/states/ParentEmptyState';
import { FiPlus, FiExternalLink } from 'react-icons/fi';
import './ParentStudents.css';

function ParentStudents() {
  const { students, switchStudent, demoState } = useParent();
  const navigate = useNavigate();
  const [showAddModal, setShowAddModal] = useState(false);

  if (demoState === 'empty' || students.length === 0) {
    return (
      <div className="parent-students">
        <h1 className="parent-page-title">Students</h1>
        <ParentEmptyState variant="no-students" onAction={() => setShowAddModal(true)} />
        {showAddModal && <AddStudentModal onClose={() => setShowAddModal(false)} />}
      </div>
    );
  }

  const statusColors = {
    'on-track': '#22c55e',
    'needs-attention': '#f59e0b',
    'at-risk': '#ef4444',
    'no-data': '#94a3b8',
  };

  return (
    <div className="parent-students">
      <div className="parent-students__header">
        <h1 className="parent-page-title">Students</h1>
        <button className="parent-students__add-btn" onClick={() => setShowAddModal(true)}>
          <FiPlus size={16} /> Add Student
        </button>
      </div>

      <div className="parent-students__grid">
        {students.map(student => (
          <div key={student.id} className="parent-student-card">
            <div className="parent-student-card__avatar">
              {student.firstName[0]}{student.lastName[0]}
            </div>
            <div className="parent-student-card__info">
              <h3 className="parent-student-card__name">{student.firstName} {student.lastName}</h3>
              <span className="parent-student-card__meta">Grade {student.grade} • {student.school}</span>
              <div className="parent-student-card__badges">
                <span className="parent-student-card__status" style={{ color: statusColors[student.overallStatus], background: `${statusColors[student.overallStatus]}12` }}>
                  {student.overallStatus.replace('-', ' ')}
                </span>
                <span className="parent-student-card__connection">{student.connectionStatus}</span>
              </div>
              <span className="parent-student-card__last-active">Last active: {student.lastActive}</span>
            </div>
            <div className="parent-student-card__actions">
              <button
                className="parent-student-card__action-btn"
                onClick={() => { switchStudent(student.id); navigate('/parent/overview'); }}
              >
                <FiExternalLink size={14} /> View Dashboard
              </button>
            </div>
          </div>
        ))}
      </div>

      {showAddModal && <AddStudentModal onClose={() => setShowAddModal(false)} />}
    </div>
  );
}

export default ParentStudents;
